(function () {
      console.log("testing1 BayState");
  const U = () => window.ProductDecoration.utils;

  function calc(ctx) {
    const detail = ctx.detail || {};
    const details = ctx.details || [];
    const qty = Number(ctx.qty || 0);
    const colorCount = Number(ctx.colorCount || 0);
    const imprintTypes = String(detail.imprint_type || "").toLowerCase();

    const decorationData = ctx.decorationData;
    const matched = U().findDecorationEntry(decorationData, details, detail, imprintTypes);
    const charges = matched?.charges || [];

    const setupPriceFallback = Number(ctx.setupPrice || 0);
    const runPriceFallback = Number(ctx.runPrice || 0);

    const setupList = charges.flat().filter((c) => c?.type === "Setup");
    const runList = charges.flat().filter((c) => c?.type === "Run");

    let setupobj = null;
    let runobj = null;

    // ---- Setup logic (same as your code): totalSetupCharge = setupPrice
    // But we try to pick a setup object (best effort) for storage/debug.
    setupobj =
      setupList.find((c) => String(c?.y_min_qty) === "*") ||
      U().pickMaxPrice(setupList) ||
      null;

    const totalSetupCharge = setupPriceFallback;

    // ---- Pad/Screen/Hot stamped: special "Additional Imprint Colors"
    if (["pad printed", "pad", "screen", "hot stamped"].includes(imprintTypes)) {
      // Prefer explicit AIC run object if present (this matches your old logic)
      const aic = runList.find((c) => String(c?.name || "").toLowerCase() === "additional imprint colors");

      if (aic) {
        runobj = aic;
        const aicRun = Number(aic.price_usd || 0);
        const perUnitExtra = aicRun * Math.max(colorCount - 1, 0);
        const totalRunCharge = perUnitExtra * qty;

        return { totalSetupCharge, totalRunCharge, setupobj, runobj };
      }

      // Otherwise: runPrice * qty (same as your code)
      // Try to pick a tiered run object if available; else fallback.
      const tier = U().closestLowerTierQty(qty, runList);
      runobj =
        runList.find((c) => parseInt(c?.x_min_qty, 10) === tier) ||
        U().pickMaxPrice(runList) ||
        null;

      const runUnit = Number(runobj?.price_usd || runPriceFallback || 0);
      const totalRunCharge = runUnit * qty;

      return { totalSetupCharge, totalRunCharge, setupobj, runobj };
    }


    if (imprintTypes === "screen printed") {
      console.log("testing-baystate");
      // Prefer explicit AIC run object if present (this matches your old logic)
      const aic = runList.find((c) => String(c?.name || "").toLowerCase() === "additional imprint colors");
      console.log("testing-baystate",aic);

      if (aic) {
        runobj = aic;
        const aicRun = Number(aic.price_usd || 0);
        const perUnitExtra = aicRun * Math.max(colorCount - 1, 0);
        const totalRunCharge = perUnitExtra * qty;

        return { totalSetupCharge, totalRunCharge, setupobj, runobj };
      }

      // Otherwise: runPrice * qty (same as your code)
      // Try to pick a tiered run object if available; else fallback.
      setupobj =
      setupList.find((c) => String(c?.name) === "Setup Charge");

      if (setupobj?.price_usd == 20){
        const tier = U().closestLowerTierQty(qty, runList);
        runobj =
          runList.find((c) => parseInt(c?.x_min_qty, 10) === tier) ||
          U().pickMaxPrice(runList) ||
          null;
        const setupUnit = Number(setupobj?.price_usd || runPriceFallback || 0);
        const runUnit = Number(runobj?.price_usd || runPriceFallback || 0);
        const totalSetupCharge = setupUnit * colorCount;
        const totalRunCharge = runUnit * qty;

        return { totalSetupCharge, totalRunCharge, setupobj, runobj };

      }
      else{
        const tier = U().closestLowerTierQty(qty, runList);
        runobj =
          runList.find((c) => parseInt(c?.x_min_qty, 10) === tier) ||
          U().pickMaxPrice(runList) ||
          null;
        const runUnit = Number(runobj?.price_usd || runPriceFallback || 0);
        const totalRunCharge = runUnit * qty;

        return { totalSetupCharge, totalRunCharge, setupobj, runobj };
    
      }
    }

    // ---- Digital / Full color / Laser: runPrice * qty (same as your code)
    if (["digital 4-color", "full color digital", "laser engrave", "laser engraved"].includes(imprintTypes)) {
      const tier = U().closestLowerTierQty(qty, runList);
      runobj =
        runList.find((c) => parseInt(c?.x_min_qty, 10) === tier) ||
        U().pickMaxPrice(runList) ||
        null;

      const runUnit = Number(runobj?.price_usd || runPriceFallback || 0);
      const totalRunCharge = runUnit * qty;

      return { totalSetupCharge, totalRunCharge, setupobj, runobj };
    }

    // ---- Fallback: runPrice * qty (same as your code)
    const tier = U().closestLowerTierQty(qty, runList);
    runobj =
      runList.find((c) => parseInt(c?.x_min_qty, 10) === tier) ||
      U().pickMaxPrice(runList) ||
      null;

    return {
      totalSetupCharge,
      totalRunCharge: Number(runobj?.price_usd || runPriceFallback || 0) * qty,
      setupobj,
      runobj,
    };
  }

  const supplier = {
    calcOnQty: calc,
    calcOnColor: calc,
  };

  window.ProductDecoration.registerSupplier("baystate", supplier);
  window.ProductDecoration.registerSupplier("Baystate", supplier);

  console.log("✅ Registered Baystate supplier handler");
})();
